// extracted by mini-css-extract-plugin
export default {"adSkip":"AdsSkip_adSkip__D-jrq","adSkipHorizontal":"AdsSkip_adSkipHorizontal__J680V","disabled":"AdsSkip_disabled__ULiIF","enabled":"AdsSkip_enabled__1pb0n"};